import React from "react";
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { DialogEnums, StyleEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import AnnualAccountOrderK10FormContainer from "./orderK10FormContainer";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useAnnualAccountOrderK10Dialog(onOrderK10Success?: (value?: any) => void) {
  const getOrderK10Dialog = (id: number): DialogProps => ({
    isOpen: false,
    title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.AnnualAccount.K10OrderDialogTitle),
    titleIcon: IconDefinitionConstants.WCommentDots,
    hideDivider: true,
    cancelButtonText: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.AnnualAccount.K10OrderBackButton),
    actions: [
      {
        text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.AnnualAccount.K10OrderButtonText),
        type: StyleEnums.DisplayType.Info,
        successMessage: TranslationKeys.AnnualAccount.K10OrderSuccessMessage,
      },
    ],
    dialogType: DialogEnums.DialogType.Content,
    children: <AnnualAccountOrderK10FormContainer id={id} onOrderSuccess={onOrderK10Success} />,
    maxWidth: "sm",
  });

  return getOrderK10Dialog;
}

export default useAnnualAccountOrderK10Dialog;
